import React, { Component } from 'react';
import { Menu, MenuItem, MenuDivider, Popover, Position, PopoverInteractionKind } from "@blueprintjs/core";
import {
    Transition, Grid, Segment, Button, Divider,
    List, Header, Icon, Modal, Dimmer, Sidebar, Image, Popup, Label, Dropdown
} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import AgencyInfo from './AgencyInfo';
import { PtSelect } from './grit-utilities';
import './grit-utilities';
import ReactToPrint from 'react-to-print';
import ConstructionSegment from './layers/cons-segment';
import Signs from './layers/signs';
import MinorStructures from './layers/minor-structs';
import OwnerLoadLimits from './layers/owner-load-limits';
import ConstructionPlanning from './layers/cons-planning';
import VRIC from './layers/vric';
import DateManager from './layers/datemanager';
import StockManager from './layers/stockmanager'
import DropdownLib from './DropdownLib';
import TownshipInfo from './TownshipInfo';
import $ from 'jquery';
import config from './config';
import PQIGraph from './reports/pqi-graph.js';
import SurfAgeGraph from './reports/surfAge-graph.js';
import PropTypes from 'prop-types';
import axios from 'axios';

const ViewState = {
    New: 0,
    View: 1,
    Edit: 2
}

const PointBasedLayers = [
    3, 6
];

const ag = new AgencyInfo()

export default class MainMenu extends Component {
    static GetPointBasedLayers() {
        return PointBasedLayers;
    }
    static propTypes = {
        enableTransition: PropTypes.bool
    }
    static defaultProps = {
        enableTransition: false
    }

    // requires map object.
    constructor(props) {
        super(props);
        this.isHiding = true;
        this.layerSelected = 'none';
        this.user = JSON.parse(sessionStorage.getItem('user'))
        let selectedState = 1;
        let selectedAgency = null;

        if (this.user && this.user.isSuperAdmin) {
            selectedAgency = ag.getSelectedAgencyId();
            selectedState = this.user && this.user.state ? this.user.state : 1;
            selectedState &&
                this.changeState(selectedState);
        }

        this.state = {
            layerSelected: 'none',
            visible: false,
            menuVisible: true,
            showData: false,
            dataModel: [],
            currentViewState: ViewState.New,

            editMode: false,
            layerHtml: <div></div>,
            loadData: null,
            needSave: false,

            mapContents: <div style={{
                width: '100%', height: '100%',
                backgroundColor: '#DDDDDD'
            }}></div>
            ,

            overlappingModalOpen: false,
            errorModalOpen: false,
            loadingModalOpen: false,
            deleteModalOpen: false,
            saveModalOpen: false,
            lpSurfModalOpen: false,
            primaryPanelModalOpen: false,
            primaryPanelCodeModalOpen: false,

            activeIndex: 0,
            previousPane: 'Inventory',
            backgroundLayer: 'none',
            backgroundLegend: [],
            legendName: '',
            shouldNewWindow: false,
            isCopyAttributeMode: false,

            showRuler: false,
            deleteDisabled: false,
            isLocationEditedForConsSeg: false,
            dateManagerBtn: false,
            permissions: [],
            superAdminPermission: [],
            addEditPermission: [],
            selectedState: selectedState,
            selectedAgency: selectedAgency
        };
        console.log(this.state.permissions);

        this.layersIndex =
        {
            'none': 0,
            'ConstructionSegment': 1,
            'OwnerLoadLimits': 2,
            'MinorStructures': 3,
            'ConstructionPlanning': 4,
            'VRIC': 5,
            'Signs': 6
        };

        this.selectCallback = null;
    }

    setPreviousPane = (name) => this.setState({ previousPane: name });

    optionsState = [
        { key: '1a', text: 'All', value: 1 },
        { key: '2nd', text: 'ND', value: 2 },
        { key: '3mn', text: 'MN', value: 3 },
        { key: '4sd', text: 'SD', value: 4 },
    ];

    agencyOptions = [];

    layerSwitch() {
        return (
            <div>
                {this.state.layerSelected === 'none' && <div></div>}
                {this.state.layerSelected === 'ConstructionSegment' &&
                    <ConstructionSegment clickFunctions={this.props.clickFunctions}
                        agencyId={this.props.ag.agencyId}
                        isLocationChanged={this.handleLocationEdit}
                        showSpinner={this.handleLoadingOpen}
                        setPreviousPane={this.setPreviousPane}
                        prevPane={this.state.previousPane}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        deleteDisabled={(bool) => { this.setState({ deleteDisabled: bool }) }}
                        setToShow={this.setToShow}
                        layerName='Construction Segment' />
                }
                {this.state.layerSelected === 'OwnerLoadLimits' &&
                    <OwnerLoadLimits clickFunctions={this.props.clickFunctions}
                        isLocationChanged={this.handleLocationEdit}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        layerName='Owner/Load Limits' />
                }
                {this.state.layerSelected === 'MinorStructures' &&
                    <MinorStructures clickFunctions={{ ...this.props.clickFunctions, loadBackgroundLayer: (layer) => this.props.selectBackgroundLayer(layer) }}
                        markerSelect={this.props.clickFunctions.updateMSMarker}
                        markerApprove={this.clickSave}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        loggedin={this.props.ag.loggedIn} showSpinner={this.handleLoadingOpen}
                        layerName='Minor Structures' />
                }
                {this.state.layerSelected === 'ConstructionPlanning' &&
                    <ConstructionPlanning clickFunctions={{ ...this.props.clickFunctions, loadConstructionHistory: this.loadSpecialLayer, loadBackgroundLayer: (layer) => this.props.selectBackgroundLayer(layer) }}
                        isLocationChanged={this.handleLocationEdit}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        layerName='Construction Planning'
                        showSpinner={this.handleLoadingOpen}
                        getroutes={this.getRoutes}
                    />
                }
                {this.state.layerSelected === 'VRIC' &&
                    <VRIC clickFunctions={this.props.clickFunctions}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        VRICPhotos={this.props.VRICPhotos}
                        UpdateVRICPhotos={this.props.UpdateVRICPhotos}

                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        layerName='Virtual Image Capture' />
                }
                {this.state.layerSelected === 'Signs' && // This is mostly copied from a combo of minor structures and construction segment
                    <Signs clickFunctions={this.props.clickFunctions}
                        isLocationChanged={this.handleLocationEdit}
                        showSpinner={this.handleLoadingOpen}
                        setPreviousPane={this.setPreviousPane}
                        prevPane={this.state.previousPane}
                        triggerNeedSave={this.triggerNeedSave} disabled={!this.state.editMode}
                        dataModel={this.state.dataModel} loadData={this.state.loadData}
                        activeIndex={this.state.activeIndex} updateActiveIndex={this.updateActiveIndex}
                        loggedin={this.props.ag.loggedIn}
                        deleteDisabled={(bool) => { this.setState({ deleteDisabled: bool }) }}
                        setToShow={this.setToShow}
                        saveFn={this.clickSave}
                        availablepanels={this.props.SignLayerAvailablePanels}
                        needSave={this.state.needSave}
                        layerName='Signs' />
                }
            </div>
        );
    }

    refreshLayer = () => {
        if (this.state.backgroundLayer !== "SpecialConstructionHistory")
            this.selectBackgroundLayer(this.state.backgroundLayer);
    }

    setToShow = () => {
        this.setState({ showData: false })
    }



    updateActiveIndex = (activeIndex) => {
        this.setState({ activeIndex: activeIndex });
    }



    triggerNeedSave = () => {
        this.setState({ needSave: true });
    }

    render() {
        return (
            <div className="mapStyle">
                {this.renderContent()}
            </div>
        );
    }

    /*
     * This function renders the map and all of the elements in it.
     */
    renderContent() {
        let i = 0;
        // map background layers to stuff
        const legend = this.state.backgroundLegend.map((l) => {
            return (
                <List.Item key={i++}>
                    {/*<Label circular empty style={{ backgroundColor: l.Color }}></Label>*/}
                    <span className="color-bubble" style={{ backgroundColor: l.Color, marginRight: 5 }}></span>
                    <List.Content as="span">{l.Category}</List.Content>
                </List.Item>
            );
        });
        const agency = ag.getSelectedAgencyData();
        return (
            <div id="mapContents" className="mapStyle">
                {this.props.mapRender}
                {this.renderSliderUI(legend, agency)}
            </div>);
    }

    renderBoxContent() {
        const datamanBtn = this.user && this.user.isSuperAdmin ?
            {
                float: 'right',
                marginTop: this.props.dateManagerComp || this.props.stockManagerComp ? '-35px' : '-80px',
                marginRight: '18px'
            } :
            {
                float: 'right',
                marginTop: this.props.dateManagerComp || this.props.stockManagerComp ? '-0px' : '-80px'
            };

        return (
            <div>
                {window.mobileAndTabletcheck() && (this.layerSelected === 'none') && <div><h4>Select a layer above to work with</h4></div>}
                <Transition visible={this.state.showData}
                    onHide={() => {
                        if (!this.isHiding) {
                            console.log("coming up");
                            this.toggleShowData();
                        }
                    }}
                    animation="fade down" duration={500}>
                    <div>
                        {/*Reset load data to avoid data structure cross overs between layers.*/}

                        {(this.state.currentViewState === ViewState.New) &&
                            <div>
                                {!this.props.isPublic && !this.props.dateManagerComp && !this.props.stockManagerComp &&
                                    ((this.user && !this.user.isSuperAdmin) &&
                                        this.state.addEditPermission.includes(this.layersIndex[this.layerSelected]) ||
                                        (this.user && this.user.isSuperAdmin &&
                                            this.state.superAdminPermission.includes(this.layersIndex[this.layerSelected]))) &&
                                    <div><Button color='blue' onClick={() => {
                                        // Triggers fresh new.
                                        if (this.state.layerSelected == 'ConstructionSegment') {
                                            this.setState({ previousPane: 'Inventory' });
                                        }
                                        this.setState({
                                            currentViewState: ViewState.Edit,
                                            layerSelected: this.layerSelected,
                                            loadData: null,
                                            editMode: true,
                                            activeIndex: 0,
                                            deleteDisabled: true
                                        });
                                    }}>New</Button>

                                        <h5>Or Select pin from Map</h5>{window.mobileAndTabletcheck() && <h5>Use the collapse button to view Map</h5>}
                                    </div>
                                }

                                {this.state.dateManagerBtn &&
                                    ((this.user && !this.user.isSuperAdmin) &&
                                        this.state.addEditPermission.includes(this.layersIndex[this.layerSelected]) ||
                                        (this.user && this.user.isSuperAdmin &&
                                            this.state.superAdminPermission.includes(this.layersIndex[this.layerSelected]))) &&
                                    <div style={datamanBtn}>
                                        <Button color='green'
                                            onClick={() => {
                                                this.props.setDateManagerComp(!this.props.dateManagerComp);
                                            }}>
                                            {this.props.dateManagerComp ? "Back to Inventory" : "Date Manager"}
                                        </Button>
                                    </div>
                                }

                                {(this.state.layerSelected == 'Signs') &&
                                    ((this.user && !this.user.isSuperAdmin) &&
                                        this.state.addEditPermission.includes(this.layersIndex[this.layerSelected]) ||
                                        (this.user && this.user.isSuperAdmin &&
                                            this.state.superAdminPermission.includes(this.layersIndex[this.layerSelected]))) &&
                                    <div style={datamanBtn}>
                                        <Button color='green'
                                            onClick={() => {
                                                this.props.setStockManagerComp(!this.props.stockManagerComp);
                                            }}>
                                            {this.props.stockManagerComp ? "Back to Inventory" : "Stock Manager"}
                                        </Button>
                                    </div>
                                }

                            </div>
                        }
                    </div>
                </Transition>
            </div>
        );
    }

    renderMenuBottomBar() {
        return (<div>
            {this.props.dateManagerComp && <DateManager agencyId={this.props.ag.getSelectedAgencyId()} loggedin={this.props.ag.loggedIn}
                triggerNeedSave={this.triggerNeedSave}
                markerSelect={this.props.clickFunctions.onSelect}
                handleLoadingOpen={this.handleLoadingOpen} />}

            {this.props.stockManagerComp && <StockManager agencyId={this.props.ag.getSelectedAgencyId()} loggedin={this.props.ag.loggedIn}
                triggerNeedSave={this.triggerNeedSave}
                markerSelect={this.props.clickFunctions.onSelect}
                handleLoadingOpen={this.handleLoadingOpen} />}

            {/*View only state is now available, but its built in so that it can propogate downwards.*/}
            {
                this.state.currentViewState === ViewState.Edit &&
                (<div>
                    {this.layerSwitch()}

                    <Divider hidden />
                    {/* would be nice to bind this to the bottom, move up other elements, and fit everything in page.*/}
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Grid>
                                    {!this.props.isPublic &&
                                        ((this.user && !this.user.isSuperAdmin) &&
                                            this.state.addEditPermission.includes(this.layersIndex[this.layerSelected]) ||
                                            (this.user && this.user.isSuperAdmin &&
                                                this.state.superAdminPermission.includes(this.layersIndex[this.layerSelected]))) &&
                                        <Grid.Row>
                                            <Grid.Column width={14}>
                                                <Button size='tiny' onClick={() => {
                                                    if (this.state.needSave) {
                                                        console.log("uno")
                                                        this.setState({ saveModalOpen: true, requireNew: true });
                                                    }
                                                    // Triggers a timed cancel and retriggers a new. TODO: find a way to not have to go through that flashy screen.
                                                    else {
                                                        if (this.state.layerSelected == 'ConstructionSegment') {
                                                            this.setState({ previousPane: 'Inventory' });
                                                        }
                                                        this.setState({
                                                            currentViewState: ViewState.New,
                                                            editMode: true,
                                                            showData: false,
                                                            loadData: null,
                                                            activeIndex: 0
                                                        });
                                                        this.isHiding = false;
                                                        this.props.clickFunctions.onCancelEdit();
                                                    }

                                                }} color='blue'>New</Button>
                                                {this.state.editMode ?
                                                    <span>
                                                        {this.state.needSave ?
                                                            <Button id="savebutton" size='tiny' color='teal'
                                                                onClick={() => {
                                                                    this.clickSave();

                                                                }}>Save</Button>
                                                            :
                                                            <Button size='tiny' disabled>Save</Button>
                                                        }
                                                        <Button size='tiny' color={this.state.deleteDisabled ? 'grey' : 'red'} onClick={() => {
                                                            // Triggers delete.
                                                            this.setState({ deleteModalOpen: true });
                                                        }} disabled={this.state.deleteDisabled} > Delete</Button>
                                                    </span>
                                                    :
                                                    <span>
                                                        <Button size='tiny' onClick={(e) => {
                                                            // Triggers edit mode.
                                                            this.setState({ editMode: !this.state.editMode });
                                                        }}
                                                            color={this.state.editMode ? 'blue' : 'green'}>Edit</Button>
                                                    </span>
                                                }
                                                <Button size='tiny' onClick={() => {
                                                    console.log('need save is ' + this.state.needSave)
                                                    if (this.state.needSave)
                                                        this.setState({ saveModalOpen: true, requireCancel: true });
                                                    else {
                                                        if (this.state.backgroundLayer === "SpecialConstructionHistory") {
                                                            this.selectBackgroundLayer('none');
                                                        }
                                                        this.setState({
                                                            currentViewState: ViewState.New,
                                                            editMode: false,
                                                            needSave: false
                                                        });
                                                        this.isHiding = false;
                                                        this.props.clickFunctions.onCancelEdit();
                                                        this.props.toggleCrosshair();
                                                    }
                                                }}>Cancel</Button>
                                            </Grid.Column>

                                            {/* This is for displaying the copy options */}
                                            {this.state.editMode &&
                                                <Grid.Column floated='left'>
                                                    <Popover interactionKind={PopoverInteractionKind.HOVER} style={{ width: '200 !important' }} content={
                                                        <Menu>
                                                            <MenuDivider title="Copy Options" />
                                                            <MenuDivider />
                                                            <MenuItem key="attributes" text="Copy Attributes" active onClick={() => { this.copyDataModel(this.state.dataModel[0]); }} />
                                                        </Menu>} position={Position.BOTTOM_LEFT}>
                                                        <Button icon color='teal' size='tiny'>
                                                            <Icon name='copy' />
                                                        </Button>
                                                    </Popover>
                                                </Grid.Column>}
                                        </Grid.Row>
                                    }
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>)
            }
            <div>
                {/* Modal for when start and end points not selected. */}
                <Modal
                    open={this.state.townshipModal}
                    onClose={() => { this.handleTownshipModal(false) }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Project Info Township!' />

                    <Modal.Content>
                        <p>Please select Township (required) field from Project Info tab</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.handleTownshipModal(false) }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.overlappingModalOpen}
                    onClose={() => { this.handleOverlappingModalOpen(false) }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Overlapping Segment!' />

                    <Modal.Content>
                        <p>The segment entered overlaps an existing segment. Please cancel the new segment and modify the existing segment start or end location to avoid overlapping. Or modify the attributes of the new segment if this is an overlay or maintenance work.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.handleOverlappingModalOpen(false) }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.modalOpen}
                    onClose={() => { this.handleModalOpen(false) }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Incomplete Route!' />

                    <Modal.Content>
                        <p>Please fill in start/end points of the route before saving.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.handleModalOpen(false) }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Modal for when Last Project Surface not selected. */}
                <Modal
                    open={this.state.lpSurfModalOpen}
                    onClose={() => { this.setState({ lpSurfModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Incomplete Route!' />
                    <Modal.Content>
                        <p>Please select a Last Project Surface type before saving the route.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.setState({ lpSurfModalOpen: false }); }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Modal when there is no primary Panel For Sign Layer  primaryPanelCodeModalOpen */}
                <Modal
                    open={this.state.primaryPanelModalOpen}
                    onClose={() => { this.setState({ primaryPanelModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Incomplete Primary Panel!' />
                    <Modal.Content>
                        <p>Primary Panel is Missing. Please add a Primary panel to save Sign Location!!</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.setState({ primaryPanelModalOpen: false }); }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Modal when there is no Panel Code for Primary Panel For Sign Layer  primaryPanelCodeModalOpen */}
                <Modal
                    open={this.state.primaryPanelCodeModalOpen}
                    onClose={() => { this.setState({ primaryPanelCodeModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='browser' content='Incomplete Primary Panel!' />
                    <Modal.Content>
                        <p>Primary Panel Sign Type is Missing. Please add a Sign Type to save Sign Location!!</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => { this.setState({ primaryPanelCodeModalOpen: false }); }} inverted>
                            <Icon name='checkmark' />Ok
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Modal for when data is deleted. */}
                <Modal
                    open={this.state.deleteModalOpen}
                    onClose={() => { this.setState({ deleteModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='trash' content='Delete Route' />
                    <Modal.Content>
                        <p>Are you sure you would like to delete this route?</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => {
                            this.setState({ deleteModalOpen: false });
                            //Confirm delete
                            this.clickDelete();
                            this.setState({ currentViewState: ViewState.New, editMode: false });
                            this.props.clickFunctions.onCancelEdit();
                        }} inverted>
                            <Icon name='checkmark' />Yes
                        </Button>
                        <Button color='red' onClick={() => { this.setState({ deleteModalOpen: false }); }} inverted>
                            <Icon name='checkmark' />No
                        </Button>
                    </Modal.Actions>
                </Modal>
                {/* Modal for when user accidentally hits new */}
                <Modal
                    open={this.state.shouldNewWindow}
                    onClose={() => { this.setState({ shouldNewWindow: false }); }}
                    basic
                    size='small'>
                    <Header icon='trash' content='Open New' />
                    <Modal.Content>
                        <p>There are unsaved changes. Are you sure you would like to continue?</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => {
                            this.setState({ shouldNewWindow: false });
                            this.setState({
                                currentViewState: ViewState.New,
                                editMode: true,
                                showData: false,
                                loadData: null
                            });
                            this.isHiding = false;
                            this.props.clickFunctions.onCancelEdit();
                        }} inverted>
                            <Icon name='checkmark' />Yes
                        </Button>
                        <Button color='red' onClick={() => { this.setState({ shouldNewWindow: false }); }} inverted>
                            <Icon name='checkmark' />No
                        </Button>
                    </Modal.Actions>
                </Modal>
                {/* Modal for when data needs saving, should call upon Cancel or Change. */}
                <Modal
                    open={this.state.saveModalOpen}
                    onClose={() => { this.setState({ saveModalOpen: false }); }}
                    basic
                    size='small'>
                    <Header icon='save' content='Save Route?' />
                    <Modal.Content>
                        <p>Warning you have unsaved changes! Click <Header as='b' color='green'>Save</Header> and continue to selected route,
                            or <Header as='b' color='red'>Discard</Header>  changes and contiue.
                            Click <Header as='b' color='yellow'>Cancel</Header> to go back, make changes, and save from menu.</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={() => {
                            //Confirm save
                            this.setState({ saveModalOpen: false, needSave: false });
                            this.clickSave();
                            if (this.state.requireNew) {
                                this.setState({
                                    currentViewState: ViewState.New,
                                    editMode: true,
                                    showData: false,
                                    loadData: null
                                });
                                this.isHiding = false;
                                this.props.clickFunctions.onCancelEdit();
                                this.setState({ requireNew: false });
                            }
                            else if (this.state.requireCancel) {
                                this.setState({ currentViewState: ViewState.New, editMode: false, needSave: false, requireCancel: false });
                                this.props.clickFunctions.onCancelEdit();
                                this.props.toggleCrosshair();
                                if (this.state.backgroundLayer === "SpecialConstructionHistory") {
                                    this.selectBackgroundLayer('none');
                                }
                            }
                        }} inverted>
                            <Icon name='trash outline' />Save
                        </Button>
                        <Button color='red' onClick={() => {
                            // discard changes
                            this.setState({ saveModalOpen: false, needSave: false });
                            if (this.state.requireNew) {
                                this.setState({
                                    currentViewState: ViewState.New,
                                    editMode: true,
                                    showData: false,
                                    loadData: null
                                });
                                this.isHiding = false;
                                this.props.clickFunctions.onCancelEdit();
                                this.setState({ requireNew: false });
                            }
                            else if (this.state.requireCancel) {
                                console.log(this.state)
                                console.log('requires cancel');
                                this.setState({ currentViewState: ViewState.New, editMode: false, needSave: false, requireCancel: false });
                                this.props.clickFunctions.onCancelEdit();
                                this.props.toggleCrosshair();
                                if (this.state.backgroundLayer === "SpecialConstructionHistory") {
                                    this.selectBackgroundLayer('none');
                                }
                            }
                            this.getRoutes();
                        }} inverted>
                            <Icon name='trash outline' />Discard Changes
                        </Button>
                        <Button color='yellow' onClick={() => {
                            this.setState({ saveModalOpen: false });

                        }} inverted>
                            <Icon name='x' />Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>

            {/* Modal for when data is loading, dimmable. */}
            <Dimmer.Dimmable dimmed={this.state.loadingModalOpen}>
                <Dimmer page active={this.state.loadingModalOpen}>
                    <Header as='h2' icon inverted>
                        <Icon loading name='spinner' />
                        Loading...
                        <Header.Subheader>This may take a few seconds.</Header.Subheader>
                    </Header>
                </Dimmer>
            </Dimmer.Dimmable>
        </div>);
    }
    handleLocationEdit = (val) => this.setState({ isLocationEditedForConsSeg: val });

    handleTownshipModal = (val) => this.setState({ townshipModal: val })

    handleOverlappingModalOpen = (val) => this.setState({ overlappingModalOpen: val })

    handleModalOpen = (val) => this.setState({ modalOpen: val })

    handleLpSurfModalOpen = (val) => this.setState({ lpSurfModalOpen: val })

    handleSignPrimaryPanel = (val) => this.setState({ primaryPanelModalOpen: val })

    handlePrimaryPanelCode = (val) => this.setState({ primaryPanelCodeModalOpen: val })

    handleLoadingOpen = (val) => this.setState({ loadingModalOpen: val })

    getYearOptions = () => {
        const yearOptions = [];
        for (let i = 0; i < 35; i++) {
            yearOptions.push({ key: new Date().getFullYear() + i, value: new Date().getFullYear() + i, label: new Date().getFullYear() + i });
        }
        return yearOptions;
    }

    onChangeDropdownPQI = (e) => {
        const { target } = e;
        const { name, value } = target;
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            this.selectBackgroundLayer('getPQI', value);
        });
    }
    onChangeDropdownAge = (e) => {
        const { target } = e;
        const { name, value } = target;
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            this.selectBackgroundLayer('Age', value);
        });
    }

    changeState(value) {
        this.agencyOptions = [];
        const agencyDropdown = ag.getAgenciesDropdown();
        (value != 0) &&
            agencyDropdown.map((item) => {
                if (item && !item.isSuperAdmin) {
                    const itemData = { 'key': item.key, 'value': item.value, 'text': item.label };
                    if (value == 1) {
                        this.agencyOptions.push(itemData);
                    } else if (this.optionsState[value - 1] && item.state == this.optionsState[value - 1].text) {
                        this.agencyOptions.push(itemData);
                    }
                }
            });
        this.agencyOptions.sort((a, b) => a.text.localeCompare(b.text))
    }

    changeCounty(value) {
        sessionStorage.setItem('token', JSON.stringify({ id: value, logged: true }));
        this.setState({ login: true });
        ag.setAgencies(value);
        this.user &&
            sessionStorage.setItem('user', JSON.stringify({ agencyId: this.user.agencyId, 'name': this.user.name, 'email': this.user.email, isSuperAdmin: this.user.isSuperAdmin, 'state': this.state.selectedState }));
        this.exitCallbackRoute('maing-dynamic');
    }

    exitCallbackRoute = (reroute = null) => {
        let params = '/' + (reroute ? reroute : 'maing');
        let url = sessionStorage.getItem('url') + params;
        window.location.href = url;
    }

    renderSliderUI = (legend, agency) => {
        const yearOptions = this.getYearOptions();
        let RenderedLegend = '';

        if (!(this.props.hideCPLegend && this.state.backgroundLayer === "SpecialConstructionHistory")) {
            RenderedLegend = <Grid.Column largeScreen={window.mobileAndTabletcheck() ? 4 : 2} mobile={window.mobileAndTabletcheck() ? 6 : 2} floated='right'>
                <Transition visible={this.state.backgroundLayer !== 'none' || this.state.layerSelected == "Signs" || this.state.layerSelected == "MinorStructures" || this.state.layerSelected == "ConstructionPlanning"} animation="fade up" duration={500}>
                    <Segment style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }} >
                        <h6>{this.state.legendName}</h6>
                        <List>
                            {legend /* this is for the special layer stuff i think and idk if maybe can be removed? */}
                        </List>
                        {/*Insert Horizontal Year Picker Here */}


                    </Segment>
                </Transition>
            </Grid.Column>
        };

        return (
            <div style={{ height: '100%' }}>
                <Sidebar.Pushable className="disablePointer">
                    {/*Main Menu*/}
                    <Sidebar as={Segment} animation='overlay' width='thin' visible={this.state.menuVisible} icon='labeled' vertical style={{ backgroundColor: 'white' }} className={this.determinWidthAndEvent()}>
                        <Grid className="menuGrid">
                            <Grid.Row>
                                <Grid.Column width={6} floated='left'>
                                    <Popover position={Position.BOTTOM_LEFT} //position='bottom center' 
                                        interactionKind={PopoverInteractionKind.HOVER}
                                        style={{ width: '200 !important' }}
                                        content={
                                            <Menu>
                                                <MenuDivider title="Layer Select" />
                                                <MenuDivider />
                                                {this.renderLayerMenu()}
                                            </Menu>} >

                                        <Button basic size="small" style={{ padding: 6, width: 120 }} color="blue" >
                                            <Image src={require('./images/layers_32bits.png')} avatar spaced='right' />
                                            Layers
                                        </Button>
                                    </Popover>
                                </Grid.Column>

                                {/*Navigation bar*/}
                                <Grid.Column width={8} floated='right' >
                                    <Button.Group style={{ height: '36px' }}>
                                        {/*Toggle background layer icon*/}
                                        <BackgroundPopover syle={{ 'borderRadius': '5px' }}
                                            layerSelected={this.state.layerSelected}
                                            selectBackgroundLayer={this.selectBackgroundLayer}
                                            loadSpecialLayer={this.loadSpecialLayer} />
                                        {/*Reports icon*/}
                                        <ReportsPopover
                                            layerSelected={this.state.layerSelected}
                                            selectedBackgroundLayer={this.selectBackgroundLayer}
                                            loadSpecialLayer={this.loadSpecialLayer}
                                        />

                                        <Popup
                                            position='bottom center'
                                            content={<Menu><MenuDivider title={this.state.showRuler ? "Hide Ruler" : "Show Ruler"} /></Menu>}
                                            trigger={<Button icon color='blue' style={{ 'borderRadius': '4px' }}
                                                onClick={() => {
                                                    this.setState({
                                                        showRuler: !this.state.showRuler
                                                    });
                                                    this.props.clickFunctions.showHideMeaureTool(!this.state.showRuler);
                                                }}><Image src={require('./images/ruler.png')} style={{ width: 16 }} />
                                            </Button>}>
                                        </Popup>
                                        <Popup
                                            position='bottom center'
                                            content={<Menu><MenuDivider title={"Help"} /></Menu>}
                                            trigger={<Button icon onClick={() => { window.open(sessionStorage.getItem('url') + '?activeItem=Help', "_blank"); }}
                                                color='blue' style={{ 'borderRadius': '4px' }}>
                                                <Icon name="help" />
                                            </Button>}>
                                        </Popup>
                                        <Popup
                                            position='bottom center'
                                            content={<Menu><MenuDivider title={"Home"} /></Menu>}
                                            trigger={<Button icon onClick={() => { window.open(sessionStorage.getItem('url'), "_blank") }} color='blue' style={{ 'borderRadius': '4px' }} >
                                                <Icon name="home" />
                                            </Button>}>
                                        </Popup>
                                    </Button.Group>
                                </Grid.Column>

                                <Grid.Column width={2} floated='right'>
                                    {this.state.menuVisible && <Popup
                                        position='bottom center'
                                        content={'Collapse'}
                                        trigger={<Button icon color='olive'
                                            onClick={(e) => { this.setState({ menuVisible: !this.state.menuVisible }); }}>
                                            <Icon name="angle double left" />
                                        </Button>}>
                                    </Popup>}
                                </Grid.Column>
                            </Grid.Row>
                            {this.props.isPublic && <h4> VIEW ONLY MODE </h4>}
                            <Grid.Row style={{ paddingTop: 2, paddingBottom: 0, marginBottom: -6 }}>
                                <Grid.Column stretched>
                                    {this.user && this.user.isSuperAdmin &&
                                        <div className="pt-form-group pt-small" style={{ margin: 'auto', marginLeft: 0, width: 340 }}>
                                            <Button.Group basic color='blue'>
                                                <div style={{ width: 120 }}>
                                                    <Dropdown button fluid search options={this.optionsState} placeholder="State"
                                                        name="stateDropdown" value={this.state.selectedState}
                                                        onFocus={this.handleOnFocusToHideFooter}
                                                        onBlur={this.handleOnFocusToBringFooter}
                                                        onChange={(e, { value }) => {
                                                            this.setState({
                                                                selectedState: parseInt(value),
                                                                selectedAgency: 0,
                                                                shouldEnableButton: false
                                                            });
                                                            this.changeState(parseInt(value));
                                                        }} />
                                                </div>
                                                <div style={{ width: 220 }}>
                                                    <Dropdown button fluid search options={this.agencyOptions} placeholder="County"
                                                        name="agencyDropdown" value={this.state.selectedAgency}
                                                        onFocus={this.handleOnFocusToHideFooter}
                                                        onBlur={this.handleOnFocusToBringFooter}
                                                        onChange={(e, { value }) => {
                                                            this.setState({
                                                                selectedAgency: parseInt(value),
                                                                shouldEnableButton: true
                                                            });
                                                            this.changeCounty(parseInt(value));
                                                        }} />
                                                </div>
                                            </Button.Group>
                                        </div>

                                    }

                                    {this.state.layerSelected != 'none' && this.user && this.user.isSuperAdmin && <h4 style={{ marginTop: 15 }}>
                                        {this.state.layerSelected == 'ConstructionSegment' ? 'ConstructionHistory' : this.state.layerSelected}
                                    </h4>}

                                    {this.state.layerSelected != 'none' && (!this.user || !this.user.isSuperAdmin) && <h4>
                                        {agency.name} County - {this.state.layerSelected == 'ConstructionSegment' ? 'ConstructionHistory' : this.state.layerSelected}
                                    </h4>}
                                    {this.state.layerSelected == 'none' && (!this.user || !this.user.isSuperAdmin) && <h4>{agency.name} County</h4>}
                                    {this.renderBoxContent()}

                                    <div name="PQIyear" hidden={true} >
                                        <PtSelect name="selectedYearPQI" visible={this.selectBackgroundLayer} defaultVal={this.state.selectedYearPQI} label="Select Year" options={yearOptions} onChange={this.onChangeDropdownPQI} />
                                    </div>
                                    <div name="AGEyear" hidden={true} >
                                        <PtSelect name="selectedYearAGE" visible={this.selectBackgroundLayer} defaultVal={this.state.selectedYearAGE} label="Select Year" options={yearOptions} onChange={this.onChangeDropdownAge} />
                                    </div>

                                </Grid.Column>
                            </Grid.Row>


                            <Grid.Row verticalAlign="bottom">
                                <Grid.Column width={16} floated='left'>
                                    {/*config.dev && agency &&
                                    <Label color='grey'>{`${agency.name} (${agency.state}) - ${agency.type}`} </Label>
                                */}

                                    {this.renderMenuBottomBar()}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                {config.dev &&
                                    <Grid.Column>
                                        <div className="blink">This is GRIT test</div>
                                    </Grid.Column>
                                }
                            </Grid.Row>
                            {
                                ag.getToken() && ag.getToken().logged &&
                                <Grid.Row verticalAlign="bottom">
                                    <Grid.Column>
                                        {/* Log the user out by setting the token to null, redirect to login page */}
                                        <Button icon onClick={() => {
                                            sessionStorage.setItem('token', null); sessionStorage.setItem('user', null);
                                            sessionStorage.setItem('agencyLookup', null); sessionStorage.setItem('agencies', null);
                                            window.open(sessionStorage.getItem('url'), "_self");
                                        }}
                                            color='red'


                                            style={{ 'borderRadius': '4px', 'bottom': '10px' }}


                                        >
                                            Log Out
                                        </Button>
                                    </Grid.Column>
                                </Grid.Row>
                            }
                        </Grid>
                    </Sidebar>

                    {/*Map overlay contents*/}
                    <Sidebar.Pusher className="disablePointer">
                        <Grid stretched style={{ height: '100%' }} >
                            {/* only='computer' */}
                            <Grid.Column width={1} className={this.determinWidthAndEvent()} floated='left'>
                                {this.state.menuVisible &&
                                    <Popup
                                        position='right center'
                                        content={'collapse'}
                                        trigger={<Button icon color='olive'
                                            onClick={(e) => { this.setState({ menuVisible: !this.state.menuVisible }); }}
                                            style={{ zIndex: 100, top: 60, position: 'absolute', margin: 10 }}>
                                            <Icon name="angle double left" />
                                        </Button>}>
                                    </Popup>
                                }
                            </Grid.Column>
                            {RenderedLegend}
                        </Grid>

                        {!this.state.menuVisible &&
                            <Popup position="right center" trigger={<Button icon color='olive' className=" enablePointer"
                                onClick={(e) => { this.setState({ menuVisible: !this.state.menuVisible }); }} style={{ zIndex: 100, top: 60, position: 'absolute', margin: 10 }}>
                                <Icon name="angle double right" />
                            </Button>} >
                                Expand
                            </Popup>
                        }
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </div>);
    }


    renderLayerMenu() {
        let permissions = this.state.permissions;

        let renderMenu = (<div><MenuItem key="default" text="None"
            active onClick={() => {
                this.selectLayer('none')
            }} />
            <MenuItem key="ConSeg" text="Construction History"
                onClick={() => {
                    this.selectLayer('ConstructionSegment')
                    this.props.onLayerChanged('ConstructionSegment');
                }} />
            <MenuItem key="OwnLoad" text="Owner/Load Limits"
                onClick={() => {
                    this.selectLayer('OwnerLoadLimits')
                    this.props.onLayerChanged('OwnerLoadLimits');
                }} />
            <MenuItem key="MinStruc" text="Minor Structures"
                onClick={() => {
                    this.selectLayer('MinorStructures')
                    this.props.onLayerChanged('MinorStructures');
                }} />
            <MenuItem key={"ConPlan"} text="Construction Planning"
                onClick={() => {
                    this.selectLayer('ConstructionPlanning');
                    this.props.onLayerChanged('ConstructionPlanning');
                }} />
            {/* <MenuItem key="Signs" text="Signs"
                onClick={() => {
                    this.selectLayer('Signs')
                    this.props.onLayerChanged('Signs');
                }} /> */}
            {permissions.includes("Signs") && <MenuItem key="Signs" text="Signs"
                onClick={() => {
                    this.selectLayer('Signs');
                    this.props.onLayerChanged('Signs');
                }} />}
            {permissions.includes("VRIC") && <MenuItem key="VRIC" text="Virtual Image Capture"
                onClick={() => this.selectLayer('VRIC')} />}
        </div>);

        return renderMenu;
    }

    selectLayer = (name, e) => {
        this.setState({ previousPane: "Inventory", layerSelected: name })
        this.layerSelected = name;
        this.setState({ currentViewState: ViewState.New, editMode: false, needSave: false });
        this.props.clickFunctions.onCancelEdit();
        this.isHiding = false;

        if (name === 'none') {
            this.setState({
                showData: false
            });
            this.props.clickFunctions.onClearMap();
        }

        else {
            if (this.layerSelected === 'OwnerLoadLimits') {
                this.setState({
                    dateManagerBtn: true
                });
            }
            else if (this.layerSelected !== 'OwnerLoadLimits') {
                this.setState({
                    dateManagerBtn: false,
                })
                this.props.setDateManagerComp(false)
            }

            if (this.layerSelected !== 'Signs') {
                this.props.setStockManagerComp(false)
            }

            this.setState({ currentViewState: ViewState.New, updateActiveIndex: 0 });
            this.toggleShowData();
            this.getRoutes();
        }
    }
    //Selecting Background Layer Toggle
    selectBackgroundLayer = (layer, e) => {
        const county = this.props.ag.getSelectedAgencyId();
        let year;
        if (layer === 'none') {
            //clear all
            this.props.clickFunctions.onLoadBackgroundLayer([]);
            this.props.clickFunctions.toggleSpecialLayer(false);
            this.legendName = '';
            if (this.state.layerSelected == "Signs") {
                let legends = [
                    { Category: "Regulatory", Color: "#000000" },
                    { Category: "Warning", Color: "#EF7A0A" },
                    { Category: "Stop", Color: "#D20605" },
                    { Category: "All Other", Color: "#76B50D" },
                    { Category: "Newly Saved", Color: "#4DB7E0" },
                    { Category: "HP (High Priority)", Color: "#FF00FF" },
                ]
                this.setState({ backgroundLegend: legends, legendName: "Signs Category" });
            }
            if (this.state.layerSelected == "MinorStructures") {
                let legends = [
                    { Category: "Accepted", Color: "#000000" },
                    { Category: "Unapproved", Color: "#D20605" },
                ]
                this.setState({ backgroundLegend: legends, legendName: "Minor Structures" });
            }
            if (this.state.layerSelected == "ConstructionPlanning") {
                let legends = [
                    { Category: "ND Township", Color: "#4DB7E0" },
                    { Category: "All Other", Color: "#76B50D" },
                ]
                this.setState({ backgroundLegend: legends, legendName: "Type" });
            }
        }
        /* PQI or Age background layer (need year) Elliot Thompson 05/25/2021 */
        else if (layer === 'getPQI' || layer === 'Age') {
            let qryPathEnd = layer.substring(layer.length - 3); //Age or PQI
            if (e !== year) {
                year = e
            } else {
                year = new Date().getFullYear();
            }
            $.ajax({
                type: 'GET',
                url: `${config.server}\\getbackground${qryPathEnd}\\${county}\\${year}`,
                contentType: 'application/json',
                success: (data) => {
                    this.props.clickFunctions.toggleSpecialLayer(false);
                    this.setState({ backgroundLegend: data[1], legendName: data[2][0].LegendName });
                    this.props.clickFunctions.onLoadBackgroundLayer(data[0], layer);
                },
            });
        } //else if minor structures bkg layers (3)
        else if (layer === "StructureAge" || layer === "StructureMaterial" || layer === "StructureCondition" || layer === "StructureType") {
            $.ajax({
                type: 'GET',
                url: `${config.server}\\getbackground\\${layer}\\${county}`,
                contentType: 'application/json',
                success: (data) => {
                    console.log(data);
                    this.props.clickFunctions.toggleSpecialLayer(false);
                    this.setState({ backgroundLegend: data[1], legendName: data[2][0].LegendName });
                    this.props.clickFunctions.onLoadBackgroundLayer(data[0], layer);
                },
            });
        }
        else {
            $.ajax({
                type: 'GET',
                url: `${config.server}\\getbackground\\${layer}\\${county}`,
                contentType: 'application/json',
                success: (data) => {
                    console.log(data);
                    this.props.clickFunctions.toggleSpecialLayer(false);
                    this.setState({ backgroundLegend: data[1], legendName: data[2][0].LegendName });
                    this.props.clickFunctions.onLoadBackgroundLayer(data[0], layer);
                },
            });
        }
        this.setState({ backgroundLayer: layer });
    }

    toggleShowData = () => {
        if (this.layerSelected !== 'none') {

            const show = !this.state.showData;

            this.setState({
                showData: show,
                menuVisible: show
            });
            if (show) {
                this.setState({
                    layerSelected: this.layerSelected,
                });
                if (this.state.editMode) {
                    this.setState({ currentViewState: ViewState.Edit });
                }
            }
        }
    }

    /*
     Create brand new line/point with all the same previous data
    */
    copyDataModel = (dataModel) => {
        this.handleLoadingOpen(true);
        this.setState({ currentViewState: ViewState.New });
        this.props.clickFunctions.onCancelEdit();
        //not sure why...
        //const oldlayerId = dataModel.layerId;
        dataModel.layerId = -1;

        if (dataModel.point) {
            dataModel.point = {
                point: '0,0',
                structureNumber: '',
                pointDescription: '',
                inlet: '0,0',
                outlet: '0,0',
                inletElevation: 0,
                outletElevation: 0,
                isPolyLine: true
            };
            dataModel.point.id = -1;
            console.log("is point");
        }
        // TODO: Handle Virtual Image Capture
        //else if (oldlayerId == 5)
        //{

        //}
        else {
            dataModel.route = {
                id: -1, //id is not set, will be setting it soon.
                start: '0,0',
                end: '0,0',
                routeLength: 0.0,
                isPolyLine: false,
                waypoints: [],
                routeLine: null,
                hwyNum: "",
                segDesc: ""
            };
            console.log("is route");
        }
        // this timeout simulates a new piece of data being loaded, thus tricks/forces react to refresh the form
        setTimeout(() => {
            this.handleLoadingOpen(false);
            this.setState({
                editMode: true,
                showData: true,
                // isCopyAttributeMode: true,
                activeIndex: 0,
                loadData: dataModel,
                currentViewState: ViewState.Edit
            });
        }, 500);
    }



    clickSave = () => {
        const county = this.props.ag.getSelectedAgencyId(); //cass county!
        // Should this be !== for both? 06/08/2021
        if (this.state.layerSelected !== 'VRIC' && this.state.layerSelected !== 'MinorStructures' && this.state.layerSelected !== 'Signs') {
            let startArray = (this.state.dataModel[0]['route']['start']).split(',');
            let endArray = (this.state.dataModel[0]['route']['end']).split(',');

            if (this.geoCoordsAreWithinRange(startArray, endArray)) {
                const layer = this.state.dataModel[0].layer;

                //this.state.dataModel[0].agencyId = county;
                /*this.setState(prevState => {
                    const newDataModel = [...prevState.dataModel];
                    newDataModel[0].agencyId = county;
                    return {dataModel: newDataModel};
                });*/
                const AgencynewModel = [...this.state.dataModel]
                AgencynewModel[0].agencyId = county
                this.setState({ dataModel: AgencynewModel })

                //update saved route
                if (PointBasedLayers.includes(layer)) { //if layer === 3
                    // stupid but it works!
                    if (this.state.dataModel[0].point.point === '0,0' //||
                        //this.state.dataModel[0].point.inlet === '0,0'||
                        //this.state.dataModel[0].point.outlet === '0,0'
                    ) {
                        this.handleModalOpen(true);
                        return;
                    }
                }
                else if (layer === 5) // Virtual Image Capture
                {
                    console.log(this.state.dataModel[0]);
                    if (this.state.dataModel[0].point === '0,0') {
                        this.handleModalOpen(true);
                        return;
                    }
                }
                else {
                    //this.state.dataModel[0].route.routeLine = this.props.routeLine.join(' ');
                    const newModel = [...this.state.dataModel]
                    newModel[0].route.routeLine = this.props.routeLine.join(' ');
                    this.setState({ dataModel: newModel })

                    if (this.state.dataModel[0].route.start === '0,0' ||
                        this.state.dataModel[0].route.end === '0,0') {
                        this.handleModalOpen(true);
                        return;
                    }

                    if (layer === 1 && this.props.overlapingId > 0) {
                        this.handleOverlappingModalOpen(true);
                        return;
                    }

                    if (this.state.dataModel[0].route.routeLine === '') {
                        //this.state.dataModel[0].route.routeLine = this.state.dataModel[0].route.routeArray.join(' ');
                        const newModel = [...this.state.dataModel]
                        newModel[0].route.routeLine = this.state.dataModel[0].route.routeArray.join(' ');
                        this.setState({ dataModel: newModel })


                    }
                }
                if (this.props.DetourRouteLine.length > 0) {
                    //console.log(this.state.dataModel)
                    const newModel = [...this.state.dataModel]
                    newModel[0].detourRoute.DetourRouteLine = this.props.DetourRouteLine.join(' ');
                    this.setState({ dataModel: newModel })

                    if (this.state.dataModel[0].detourRoute.DetourStart === '0,0' ||
                        this.state.dataModel[0].detourRoute.DetourEnd === '0,0') {
                        this.handleModalOpen(true);
                        return;
                    }

                    if (this.state.dataModel[0].detourRoute.DetourRouteLine === '') {
                        //this.state.dataModel[0].route.routeLine = this.state.dataModel[0].route.routeArray.join(' ');
                        const newModel = [...this.state.dataModel]
                        newModel[0].detourRoute.DetourRouteLine = this.state.dataModel[0].detourRoute.DetourRouteArray.join(' ');
                        this.setState({ dataModel: newModel })


                    }
                }
                // check Last Project Surface
                if (layer === 1) {
                    if (this.state.dataModel[0].lpModel.lastProjectSurf === 0) {
                        this.handleLpSurfModalOpen(true);
                        return;
                    }
                }

                if (layer === 4 && this.state.dataModel[0].projectInfo &&
                    this.state.dataModel[0].projectInfo.type == 11) {
                    if (!this.state.dataModel[0].projectInfo.township || this.state.dataModel[0].projectInfo.township == 0) {
                        this.handleTownshipModal(true);
                        return;
                    }
                }

                // prepare for saving data.
                this.handleLoadingOpen(true);

                let finalData = { ...this.state.dataModel[0], hasLocationChanged: this.state.isLocationEditedForConsSeg };

                console.log("Check for CS save", finalData)
                $.ajax({
                    type: 'POST',
                    url: `${config.server}\\updateroute`,
                    contentType: 'application/json',
                    data: JSON.stringify(finalData),

                    success: (data) => {
                        const { route, point } = this.state.dataModel[0];
                        // set routeId/pointId on dataModel from response if inserting new route/point
                        if (route) {
                            if (this.state.dataModel[0].route.id === -1) {
                                let tempArray = this.state.dataModel.slice();
                                // grabs routeId from response string
                                tempArray[0].route.id = data.routeId;
                                this.setState({ dataModel: tempArray });
                            }
                        }
                        else if (point) {
                            if (this.state.dataModel[0].point.id && this.state.dataModel[0].point.id === -1) {
                                let tempArray = this.state.dataModel.slice();
                                // grabs pointId from response string
                                tempArray[0].point.id = data.pointId;
                                this.setState({ dataModel: tempArray });
                            }
                        }

                        if (layer == 4 && this.state.dataModel.length > 0 && this.state.dataModel[0].projectInfo) {
                            let constructionPlanningData = this.state.dataModel;
                            data.consPlanningId &&
                                (constructionPlanningData[0].layerId = data.consPlanningId);

                            constructionPlanningData[0].projectInfo.townshipId = data.townshipId;
                            this.setState({ dataModel: constructionPlanningData });
                        }

                        this.setState({ needSave: false, editMode: false, isLocationEditedForConsSeg: false });
                        this.props.clickFunctions.onSubmittedMarker(route);
                        this.getRoutes();
                        this.handleLoadingOpen(false);

                    },
                });

            }
            else {
                alert('Geographic Coordinates out of Range');
            }
        } else {
            const layer = this.state.dataModel[0].layer;

            //this.state.dataModel[0].agencyId = county;
            const newDataModel = [...this.state.dataModel];
            newDataModel[0].agencyId = county;
            this.setState({ dataModel: newDataModel });

            //update saved route
            if (PointBasedLayers.includes(layer)) {
                // stupid but it works!
                if (this.state.dataModel[0].point.point === '0,0' //||
                    //this.state.dataModel[0].point.inlet === '0,0'||
                    //this.state.dataModel[0].point.outlet === '0,0'
                ) {
                    this.handleModalOpen(true);
                    return;
                }
            }
            else if (layer === 5) // Virtual Image Capture
            {
                if (this.state.dataModel[0].point === '0,0') {
                    this.handleModalOpen(true);
                    return;
                }
            }
            else {
                //this.state.dataModel[0].route.routeLine = this.props.routeLine.join(' ');
                const newModel = [...this.state.dataModel]
                newModel[0].route.routeLine = this.props.routeLine.join(' ');
                this.setState({ dataModel: newModel })


                if (this.state.dataModel[0].route.start === '0,0' ||
                    this.state.dataModel[0].route.end === '0,0') {
                    this.handleModalOpen(true);
                    return;
                }

                if (this.state.dataModel[0].route.routeLine === '') {

                    //this.state.dataModel[0].route.routeLine = this.state.dataModel[0].route.routeArray.join(' ');
                    const newModel = [...this.state.dataModel]
                    newModel[0].route.routeLine = this.state.dataModel[0].route.routeArray.join(' ');
                    this.setState({ dataModel: newModel })

                }
            }
            // check Last Project Surface
            if (layer === 1) {
                if (this.state.dataModel[0].lpModel.lastProjectSurf === 0) {
                    this.handleLpSurfModalOpen(true);
                    return;
                }
            }
            if (layer === 6) {
                if (this.state.dataModel[0].Panel.data.length === 0) {
                    this.handleSignPrimaryPanel(true)
                    return;
                }
                else if (this.state.dataModel[0].Panel.data[0].PanelCode === null) {
                    this.handlePrimaryPanelCode(true)
                    return;
                }
            }
            // prepare for saving data.
            this.handleLoadingOpen(true);
            let finalData = { ...this.state.dataModel[0], hasLocationChanged: this.state.isLocationEditedForConsSeg };

            console.log(finalData)
            $.ajax({
                type: 'POST',
                url: `${config.server}\\updateroute`,
                contentType: 'application/json',
                data: JSON.stringify(finalData),

                success: (data) => {
                    const { route, point } = this.state.dataModel[0];
                    // set routeId/pointId on dataModel from response if inserting new route/point
                    if (route) {
                        if (this.state.dataModel[0].route.id === -1) {
                            let tempArray = this.state.dataModel.slice();
                            // grabs routeId from response string
                            tempArray[0].route.id = data.routeId;
                            this.setState({ dataModel: tempArray });
                        }
                    }
                    else if (point) {
                        if (this.state.dataModel[0].point.id && this.state.dataModel[0].point.id === -1) {
                            console.log('TempArray ', this.state.dataModel)
                            let tempArray = this.state.dataModel.slice();
                            // grabs pointId from response string
                            tempArray[0].point.id = data.pointId;
                            this.setState({ dataModel: tempArray, activeIndex: 0 });
                        }
                    }

                    if (layer == 6 && this.state.dataModel.length > 0 && this.state.dataModel[0].Support) {
                        let signData = this.state.dataModel;
                        data.signID &&
                            (signData[0].Support.SignId = data.signID);

                        this.setState({ dataModel: signData });
                    }

                    this.setState({ needSave: false, editMode: false, isLocationEditedForConsSeg: false });
                    this.props.clickFunctions.onSubmittedMarker(route);
                    this.getRoutes();
                    this.handleLoadingOpen(false);
                },
            });

        }
    }

    geoCoordsAreWithinRange = (startArray, endArray) => {
        if (parseFloat(startArray[0]) > parseFloat(24) && parseFloat(startArray[0]) < parseFloat(49.3799954)
            && parseFloat(endArray[0]) > parseFloat(24) && parseFloat(startArray[0]) < parseFloat(49.3799954)

            && parseFloat(startArray[1]) < parseFloat(-65) && parseFloat(startArray[1]) > parseFloat(-126)
            && parseFloat(endArray[1]) < parseFloat(-65) && parseFloat(endArray[1]) > parseFloat(-126)) {
            return true;
        } else {
            return false;
        }
    }

    clickDelete = () => {
        const { layer, route, point } = this.state.dataModel[0];
        let id = -1;
        if (layer === 5) {
            id = this.state.dataModel[0].layerId;
        }
        else {
            if (route) {
                id = route.id;
            }
            if (point) {
                if (point.id) {
                    id = point.id;
                }
                else {
                    id = this.state.dataModel[0].id;
                }
            }
        }
        $.ajax({
            type: 'POST',
            url: `${config.server}\\deleteroute\\${layer}\\${id}`,
            contentType: 'application/json',
            success: (data) => {
                this.getRoutes();
            },
        });
    }

    getRoutes = () => {
        const county = this.props.ag.getSelectedAgencyId(); //cass county!
        this.handleLoadingOpen(true);
        $.ajax({
            type: 'GET',
            url: `${config.server}\\getroutes\\${this.layersIndex[this.layerSelected]}\\${county}`,
            contentType: 'application/json',
            success: (data) => {
                this.props.clickFunctions.onLayerLoaded(data);
                this.handleLoadingOpen(false);
            },
        });
    }

    determinWidthAndEvent = () => {
        return window.mobileAndTabletcheck() ? "enablePointer_mobile" : "enablePointer_desktop";
    }

    // This function is used for getting a special layer from the background layers api,
    // It is designed to be an overlay snapping layer for another one.
    loadSpecialLayer = () => {
        const county = this.props.ag.getSelectedAgencyId();
        this.handleLoadingOpen(true);
        $.ajax({
            type: 'GET',
            url: `${config.server}\\getbackground\\SpecialConstructionHistory\\${county}`,
            contentType: 'application/json',
            success: (data) => {
                this.props.clickFunctions.constructionHistorySnappingLayer(data[0]);
                this.handleLoadingOpen(false);
                // TODO: add legend data?
                // '8 or more inches' as Category, '#00F014' as Color 
                this.setState({
                    backgroundLegend: [
                        { Category: "Const. History Start-End", Color: "#FBA025" },
                        { Category: "Const. Planning Start", Color: "#A6D842" },
                        { Category: "Const. Planning End", Color: "#D21200" }
                    ], legendName: "Snap Pins",
                    backgroundLayer: "SpecialConstructionHistory"
                });
            },
        });
    }

    layerSelect = () => {
        this.setState({
            showData: true
        });
    }

    loadContent = () => {
        this.setState({
            menuVisible: true
        });
    }

    finishedLoad = () => {
    }

    componentDidMount() {
        /**** WAIT HERE BEFORE LOADING.... ****/
        DropdownLib.intialize(this.handleLoadingOpen);
        TownshipInfo.intialize(this.handleLoadingOpen);
        this.setState({ visible: true });
        let agencyId = JSON.parse(sessionStorage.getItem('token')).id;
        let secondaryUserId = (this.user && this.user.secondaryUserId) ? this.user.secondaryUserId : 0;

        $.ajax({
            type: 'GET',
            url: `${config.server}/agency/${agencyId}/${secondaryUserId}/permissions`,
        })
            .done((data) => {
                this.setState({ ...this.state, permissions: data.data, addEditPermission: data.addEditPermission })
            });

        if (this.user && this.user.isSuperAdmin) {
            $.ajax({
                type: 'GET',
                url: `${config.server}/agency/${this.user.agencyId}/superadminpermissions`,
            })
                .done((data) => {
                    this.setState({ ...this.state, superAdminPermission: data.data })
                });
        }
    }


    /**
    * The marker selection procedure.
    */
    selectMarker = (markerId, markerData, layerId) => {
        // Note all behavior for marker selection will happen here.
        const selectCallback = () => { this.innerSelectCallback(markerId, markerData, layerId); };
        this.selectCallback = selectCallback;
        if (this.state.needSave) {
            this.setState({ saveModalOpen: true });
        }
        else {
            selectCallback();
        }
    }

    /*
        The actual select callback override.
    */
    innerSelectCallback = (markerId, markerData, layerId) => {
        this.handleLoadingOpen(true);
        this.setState({ currentViewState: ViewState.New });
        $.ajax({
            type: 'GET',
            url: `${config.server}\\getroutedata\\${layerId}\\${markerData.Id}`,
            contentType: 'application/json',
            success: (data) => {
                this.handleLoadingOpen(false);
                if (PointBasedLayers.includes(layerId)) {
                    data.point = markerData.pointData.point;
                }
                else if (layerId === 5) {
                    console.log('received Virtual Image Capture data'); // still no internal data to display on map
                }
                else {

                    data.route = markerData.pointData.route;
                    data.detourRoute = markerData.pointData.detourRoute;
                }
                this.props.clickFunctions.onSelect(markerId);
                if (layerId === 6)
                    this.setState({
                        deleteDisabled: false,
                        editMode: false,
                        showData: true,
                        loadData: data,
                        currentViewState: ViewState.Edit
                    });

                else
                    this.setState({
                        deleteDisabled: false,
                        editMode: false,
                        showData: true,
                        loadData: data,
                        currentViewState: ViewState.Edit
                    });
            },
        });
    }
}

/*Menu that pops up when hovering over the reports icon.*/
export class ReportsPopover extends Component {
    //generates a pdf displaying pqi graph
    // *************************CAN BE REMOVED WHEN GRAPH SUCCESFULLY OPENS IN NEW TAB********************************************
    //exportGraphPDF = () => {
    //    console.log("Export PDF");

    //    var agencyId = ag.getSelectedAgencyId();
    //    //window.open('http://dotsc.ugpti.ndsu.nodak.edu/GRIT/', "_blank");

    //    ReactDOM.render(<pqiGraph agencyId={agencyId} />, document.getElementById('graphLoad'));
    //    var doc = new jsPDF();


    //    var elementHTML = document.getElementById('graphLoad').innerHTML;
    //    var specialElementHandlers = {
    //        '#elementH': function (element, renderer) {
    //            return true;
    //        }
    //    };
    //    doc.fromHTML(elementHTML, 15, 15, {
    //        'width': 170,
    //        'elementHandlers': specialElementHandlers
    //    });
    //    doc.text('Hello world!', 10, 10);
    //    doc.save('a4.pdf');
    //}
    constructor(props) {
        super(props);
        this.state = {
            reportmodal: false,
            agencyId: ag.getSelectedAgencyId(),
            surfaceageModal: false,
            loading: false
        }
    }

    startDownload() {
        axios.get(`${config.server}\\exporttownships`).then((data) => {
            const jsonData = data && data.data ? data.data : [];
            this.downloadObjectAsCsv(jsonData, "Townships");
        }).catch(() => {
            console.error('Failed to export.');
        });
    }

    downloadObjectAsCsv(data, filename) {
        let csvContent = "";

        const headers = Object.keys(data[0]).map(header => `"${header.replace(/"/g, '""')}"`).join(",");
        csvContent += headers + "\r\n";

        data.forEach(obj => {
            const row = Object.values(obj).map(field => {
                if (field == null) field = "";
                let stringValue = field.toString();
                return `"${stringValue.replace(/"/g, '""')}"`;
            }).join(",");
            csvContent += row + "\r\n";
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", filename + ".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        const menu =
            <Menu>

                <MenuDivider title="Reports" />
                {/*<MenuItem fitted key="pqi" text="PQI Graph" onClick={() => this.setState({reportmodal: true})} />
                <MenuItem fitted key="pqione" text="PQI Graph 1" onClick={() => console.log(this.state.agencyId)} />*/}

                <MenuItem style={{ overflowX: "visible" }} fitted key="Reports" text="Performance Forecast">
                    <MenuItem fitted key="pqi" text="PQI Graph" onClick={() => this.setState({ reportmodal: true })} />
                    <MenuItem fitted key="age" text="Pavement Age Graph" onClick={() => this.setState({ surfaceageModal: true })} />
                </MenuItem>

                {/* <MenuItem style={{ overflowX: "visible" }} fitted key="Export" text="Export">
                    <MenuItem fitted key="township" text="Township" onClick={() => this.startDownload()} />
                </MenuItem> */}
            </Menu>;

        //Menu for when the user is on a smaller screen.
        const mobileMenu =
            <Menu>

            </Menu>;


        /* 
            If the mobile and table check is false, then that means the user is 
            on a smaller screen, so show them the compact menu called "mobileMenu".
            If it returns true, then that means the screen is larger, so show the 
            full menu called "menu".
        */
        return (
            <div>
                <Popup position='bottom center'
                    hoverable={window.mobileAndTabletcheck() ? false : true}
                    content={window.mobileAndTabletcheck() ? mobileMenu : menu}
                    trigger={<Button icon color='blue'> <Icon name="clipboard" /> </Button>}>
                </Popup>

                {/* Modal for Performance Forecast PQI reports */}
                <Modal open={this.state.reportmodal}
                    onClose={() => { this.setState({ reportmodal: false }); }}
                    basic size='small'>
                    <Modal.Content>
                        <ReactToPrint trigger={() => <Button color='red'>Print this out!</Button>} content={() => this.componentRef} />
                        <Button color='yellow' onClick={() => this.setState({ reportmodal: false })}>Cancel</Button>
                        <PQIGraph ref={el => (this.componentRef = el)} data={this.state.agencyId} />
                    </Modal.Content>
                    <Modal.Actions>
                    </Modal.Actions>
                </Modal>

                {/* Modal for Performance Forecast Surface Age reports */}
                <Modal open={this.state.surfaceageModal}
                    onClose={() => { this.setState({ surfaceageModal: false }); }}
                    basic size='small'>
                    <Modal.Content>
                        <ReactToPrint trigger={() => <Button color='negative'>Print this out!</Button>} content={() => this.componentRef} />
                        <Button color='yellow' onClick={() => this.setState({ surfaceageModal: false })}>Cancel</Button>
                        <SurfAgeGraph data={this.state.agencyId} ref={el => (this.componentRef = el)} />
                    </Modal.Content>
                    <Modal.Actions>

                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

export class BackgroundPopover extends Component {
    // weird bug in popover behavior doesn't allow me to update menu form. So I'll try rerendering the whole thing.
    render() {
        // Why do we have MenuA here? AFAIK it isn't used.. -Elliot Thompson 05/28/2021
        //#region unused MenuA (this is where special layer is)
        /*const MenuA = <Menu>
            <MenuDivider title="Toggle Background Layers" />
            <MenuDivider />
            <MenuItem key="default" text="none"
                active onClick={() => this.props.selectBackgroundLayer('none')} />

            <MenuItem key="CH" text="Construction History" >
                <MenuItem key="ConSeg" text="Maintenance Types" disabled={true}
                    onClick={() => this.props.selectBackgroundLayer('MaintenanceTypes')} />
                <MenuItem key="ConSeg" text="Pavement Age(Bituminous)"
                    onClick={() => this.props.selectBackgroundLayer('MaintenanceTypes')} />
                <MenuItem key="ConSeg" text="Pavement Age(Concrete)"
                    onClick={() => this.props.selectBackgroundLayer('MaintenanceTypes')} />
                <MenuItem key="SurfDepth" text="Total Surface Depth"
                    onClick={() => this.props.selectBackgroundLayer('TotalSurfaceDepth')} />
                <MenuItem key="SurfAge" text="Surface Age"
                    onClick={() => this.props.selectBackgroundLayer('SurfaceAge')} />
                <MenuItem key="ConsHistSnap" text="Construction History Snap" disabled={false}
                    onClick={() => this.props.loadSpecialLayer()} />
            </MenuItem>
            <MenuItem key="OWNL" text="Ownership Load Restrictions" >
                <MenuItem key="LoadRes" text="Load Restrictions"
                    onClick={() => this.props.selectBackgroundLayer('LoadRestrictions')} />
                <MenuItem key="Ownership" text="Ownership"
                    onClick={() => this.props.selectBackgroundLayer('Ownership')} />
            </MenuItem>
        </Menu>;
        //<MenuItem key="CD" text="Crash Data" >
        //  <MenuItem key="CS" text="Crash Severity"
        //    onClick={() => this.props.('CrashSeverity')} />
        //  <MenuItem key="LD" text="Lane Departure"
        //     onClick={() => this.props.selectBackgroundLayer('LaneDeparture')} />
        // <MenuItem key="Roll" text="Rollovers"
        //     onClick={() => this.props.selectBackgroundLayer('Rollover')} />
        // <MenuItem key="Speed" text="Speeding"
        //     onClick={() => this.props.selectBackgroundLayer('Speed')} />
        // <MenuItem key="FTY" text="Failure To Yield"
        //     onClick={() => this.props.selectBackgroundLayer('FailureToYield')} />
        //</MenuItem>*/
        //#endregion
        const MenuB = <Menu>

            <MenuDivider title="Toggle Background Layers" />
            <MenuDivider />

            <MenuItem fitted key="default" text="None"
                active onClick={() => { this.props.selectBackgroundLayer('none'); this.HideYearSelect(); }} />

            <MenuItem style={{ overflowX: "visible" }} fitted key="CH" text="Construction History" >

                <MenuItem style={{ overflowX: "visible" }} fitted key="PavAgeBit" text="Pavement Age(Bituminous)"
                    onClick={() => { this.props.selectBackgroundLayer('SurfaceAgeBitu'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="PavAgeConc" text="Pavement Age(Concrete)"
                    onClick={() => { this.props.selectBackgroundLayer('SurfaceAgeConc'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="SurfType" text="Surface Type"
                    onClick={() => { this.props.selectBackgroundLayer('SurfaceType'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="SurfDepth" text="Total Surface Depth"
                    onClick={() => { this.props.selectBackgroundLayer('TotalSurfaceDepth'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="ShoulderWidthTotal" text="Shoulder Width - Total"
                    onClick={() => { this.props.selectBackgroundLayer('ShoulderWidthTotal'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="ShoulderWidthPaved" text="Shoulder Width - Paved"
                    onClick={() => { this.props.selectBackgroundLayer('ShoulderWidthPaved'); this.HideYearSelect(); }} />

                <MenuItem style={{ overflowX: "visible" }} fitted key="RightOfWayTotal" text="Right-of-Way - Total"
                    onClick={() => { this.props.selectBackgroundLayer('RightOfWayTotal'); this.HideYearSelect(); }} />

            </MenuItem>

            <MenuItem fitted key="CPBG" text="Construction Planning" >
                <MenuItem key="PublicImpact" text="Current Year Construction (Public Impact)"
                    onClick={() => { this.props.selectBackgroundLayer('PublicImpact'); this.HideYearSelect(); }} />

                <MenuItem key="PlannedImprovement" text="Planned Improvements"
                    onClick={() => { this.props.selectBackgroundLayer('PlannedImprovement'); this.HideYearSelect(); }} />

                <MenuItem key="CurrentYearOldStatus" text="Current Year Projects with Outdated Status"
                    onClick={() => { this.props.selectBackgroundLayer('CurrentYearOldStatus'); this.HideYearSelect(); }} />


            </MenuItem>

            <MenuItem fitted key="OWNL" text="Ownership Load Restrictions" >

                <MenuItem key="LoadRes" text="Load Restrictions"
                    onClick={() => { this.props.selectBackgroundLayer('LoadRestrictions'); this.HideYearSelect(); }} />

                <MenuItem key="Ownership" text="Ownership"
                    onClick={() => { this.props.selectBackgroundLayer('Ownership'); this.HideYearSelect(); }} />

            </MenuItem>

            <MenuItem fitted key="MS" text="Minor Structures" >

                <MenuItem key="StructureMat" text="Structure Materials"
                    onClick={() => { this.props.selectBackgroundLayer('StructureMaterial'); this.HideYearSelect(); }} />

                <MenuItem key="StructureCond" text="Structure Conditions"
                    onClick={() => { this.props.selectBackgroundLayer('StructureCondition'); this.HideYearSelect(); }} />

                <MenuItem key="StructureAge" text="Structure Age"
                    onClick={() => { this.props.selectBackgroundLayer('StructureAge'); this.HideYearSelect(); }} />

                <MenuItem key="StructureType" text="Structure Type"
                    onClick={() => { this.props.selectBackgroundLayer('StructureType'); this.HideYearSelect(); }} />
            </MenuItem>

            <MenuItem fitted key="PERF" text="Performance">

                <MenuItem key="Age" text="Age"
                    onClick={() => this.AGESelected()} />

                <MenuItem key="PSR" text="PQI - Pavement Quality Index"
                    onClick={() => this.PQISelected()} />

                <MenuItem key="SN" text="Structural Number - SN"
                    onClick={() => { this.props.selectBackgroundLayer('SN'); this.HideYearSelect(); }} />

                <MenuItem key="GE" text="Granular Equivalency - GE"
                    onClick={() => { this.props.selectBackgroundLayer('GE'); this.HideYearSelect(); }} />

                <MenuItem key="AADT" text="Current Ann. Avg. Daily Traffic"
                    onClick={() => { this.props.selectBackgroundLayer('AADT'); this.HideYearSelect(); }} />

                <MenuItem key="CumEsal20Year" text="Cumulative 20 Year ESALs"
                    onClick={() => { this.props.selectBackgroundLayer('CumEsal20Year'); this.HideYearSelect(); }} />
            </MenuItem>

            <MenuItem fitted key="NDT" text="ND Townships">
                <MenuItem key="ndt-typeofwork" text="Type of Work"
                    onClick={() => { this.props.selectBackgroundLayer('ndttypeofwork'); this.HideYearSelect(); }} />
                <MenuItem key="ndt-status" text="Status"
                    onClick={() => { this.props.selectBackgroundLayer('ndtstatus'); this.HideYearSelect(); }} />
                <MenuItem key="ndt-ps" text="Proposed Surface"
                    onClick={() => { this.props.selectBackgroundLayer('ndtps'); this.HideYearSelect(); }} />
                <MenuItem key="ndt-year" text="Proposed Year"
                    onClick={() => { this.props.selectBackgroundLayer('ndtpyear'); this.HideYearSelect(); }} />
            </MenuItem>
        </Menu>;
        /* Crash data on hold as of pre 05/26/2021
        <MenuItem key="CD" text="Crash Data" >
         <MenuItem key="CS" text="Crash Severity"
           onClick={() => this.props.selectBackgroundLayer('CrashSeverity')} />
         <MenuItem key="LD" text="Lane Departure"
            onClick={() => this.props.selectBackgroundLayer('LaneDeparture')} />
        <MenuItem key="Roll" text="Rollovers"
            onClick={() => this.props.selectBackgroundLayer('Rollover')} />
        <MenuItem key="Speed" text="Speeding"
            onClick={() => this.props.selectBackgroundLayer('Speed')} />
        <MenuItem key="FTY" text="Failure To Yield"
            onClick={() => this.props.selectBackgroundLayer('FailureToYield')} />
        </MenuItem>
        */

        //const MenuMobile: 3 of 3. Editing the text property doesn't make any interface changes.
        const MenuMobile = <Menu>
            <MenuDivider title="Toggle Background Layers" />


            <MenuItem shouldDismissPopover={true} fitted key="default" text="None"
                active onClick={() => { this.props.selectBackgroundLayer('none'); this.HideYearSelect(); }} />

            <MenuDivider title="Construction History" />
            <MenuItem shouldDismissPopover={true} key="PavAgeBit" text="Pavement Age(Bituminous)"
                onClick={() => { this.props.selectBackgroundLayer('SurfaceAgeBitu'); this.HideYearSelect(); }} />
            <MenuItem key="PavAgeConc" text="Pavement Age(Concrete)"
                onClick={() => { this.props.selectBackgroundLayer('SurfaceAgeConc'); this.HideYearSelect(); }} />
            <MenuItem style={{ overflowX: "visible" }} fitted key="SurfType" text="Surface Type"
                onClick={() => { this.props.selectBackgroundLayer('SurfaceType'); this.HideYearSelect(); }} />
            <MenuItem style={{ overflowX: "visible" }} fitted key="SurfDepth" text="Total Surface Depth"
                onClick={() => { this.props.selectBackgroundLayer('TotalSurfaceDepth'); this.HideYearSelect(); }} />
            <MenuItem style={{ overflowX: "visible" }} fitted key="ShoulderWidthTotal" text="Shoulder Width - Total"
                onClick={() => { this.props.selectBackgroundLayer('ShoulderWidthTotal'); this.HideYearSelect(); }} />
            <MenuItem style={{ overflowX: "visible" }} fitted key="ShoulderWidthPaved" text="Shoulder Width - Paved"
                onClick={() => { this.props.selectBackgroundLayer('ShoulderWidthPaved'); this.HideYearSelect(); }} />
            <MenuItem style={{ overflowX: "visible" }} fitted key="RightOfWayTotal" text="Right-of-Way - Total"
                onClick={() => { this.props.selectBackgroundLayer('RightOfWayTotal'); this.HideYearSelect(); }} />


            <MenuDivider title="Construction Planning" />
            <MenuItem key="PublicImpact" text="Current Year Construction (Public Impact)"
                onClick={() => { this.props.selectBackgroundLayer('PublicImpact'); this.HideYearSelect(); }} />
            <MenuItem key="PlannedImprovement" text="Planned Improvements"
                onClick={() => { this.props.selectBackgroundLayer('PlannedImprovement'); this.HideYearSelect(); }} />
            <MenuItem key="CurrentYearOldStatus" text="Current Year Projects with Outdated Status"
                onClick={() => { this.props.selectBackgroundLayer('CurrentYearOldStatus'); this.HideYearSelect(); }} />

            <MenuDivider title="Ownership Load Restrictions" />
            <MenuItem key="LoadRes" text="Load Restrictions"
                onClick={() => { this.props.selectBackgroundLayer('LoadRestrictions'); this.HideYearSelect(); }} />
            <MenuItem key="Ownership" text="Ownership"
                onClick={() => { this.props.selectBackgroundLayer('Ownership'); this.HideYearSelect(); }} />

            <MenuDivider title="Minor Structures" ></MenuDivider>
            <MenuItem key="StructureMat" text="Structure Materials"
                onClick={() => { this.props.selectBackgroundLayer('StructureMaterial'); this.HideYearSelect(); }} />

            <MenuItem key="StructureCond" text="Structure Conditions"
                onClick={() => { this.props.selectBackgroundLayer('StructureCondition'); this.HideYearSelect(); }} />

            <MenuItem key="StructureAge" text="Structure Age"
                onClick={() => { this.props.selectBackgroundLayer('StructureAge'); this.HideYearSelect(); }} />

            <MenuItem key="StructureType" text="Structure Type"
                onClick={() => { this.props.selectBackgroundLayer('StructureType'); this.HideYearSelect(); }} />



            <MenuDivider title="Performance" ></MenuDivider>
            <MenuItem fitted key="Age" text="Age"
                onClick={() => { this.AGESelected(); }} />
            <MenuItem key="PQI" text="PQI"
                onClick={() => { this.PQISelected() }} />
            <MenuItem key="SN" text="Structural Number - SN"
                onClick={() => { this.props.selectBackgroundLayer('SN'); this.HideYearSelect(); }} />
            <MenuItem key="GE" text="Granular Equivalency - GE"
                onClick={() => { this.props.selectBackgroundLayer('GE'); this.HideYearSelect(); }} />
            <MenuItem key="AADT" text="Current Ann. Avg. Daily Traffic"
                onClick={() => { this.props.selectBackgroundLayer('AADT'); this.HideYearSelect(); }} />
            <MenuItem key="CumEsal20Year" text="Cumulative 20 Year ESALs"
                onClick={() => { this.props.selectBackgroundLayer('CumEsal20Year'); this.HideYearSelect(); }} />

            <MenuDivider title="ND Townships" ></MenuDivider>
            <MenuItem key="ndt-typeofwork" text="Type of Work"
                onClick={() => { this.props.selectBackgroundLayer('ndt-typeofwork'); this.HideYearSelect(); }} />
            <MenuItem key="ndt-status" text="Status"
                onClick={() => { this.props.selectBackgroundLayer('ndt-status'); this.HideYearSelect(); }} />
            <MenuItem key="ndt-ps" text="Proposed Surface"
                onClick={() => { this.props.selectBackgroundLayer('ndt-ps'); this.HideYearSelect(); }} />
            <MenuItem key="ndt-year" text="Proposed Year"
                onClick={() => { this.props.selectBackgroundLayer('ndt-year'); this.HideYearSelect(); }} />

        </Menu>;
        /* Crash data on hold as of pre 05/26/2021
        <MenuItem key="CD" text="Crash Data" >
         <MenuItem key="CS" text="Crash Severity"
           onClick={() => this.props.selectBackgroundLayer('CrashSeverity')} />
         <MenuItem key="LD" text="Lane Departure"
            onClick={() => this.props.selectBackgroundLayer('LaneDeparture')} />
        <MenuItem key="Roll" text="Rollovers"
            onClick={() => this.props.selectBackgroundLayer('Rollover')} />
        <MenuItem key="Speed" text="Speeding"
            onClick={() => this.props.selectBackgroundLayer('Speed')} />
        <MenuItem key="FTY" text="Failure To Yield"
            onClick={() => this.props.selectBackgroundLayer('FailureToYield')} />
        </MenuItem>
        */
        return (<Popup
            position='bottom center'
            hoverable={window.mobileAndTabletcheck() ? false : true}
            content={
                //this.props.layerSelected === "ConstructionPlanning" ? MenuA : MenuB
                window.mobileAndTabletcheck() ? MenuMobile : MenuB
            }
            trigger={<Button icon color='green'> <Icon name="map outline" />
            </Button>}>
        </Popup>);
    }

    //for PQI year selector
    PQISelected() {
        this.props.selectBackgroundLayer('getPQI');
        var age = document.getElementsByName("AGEyear");
        if (age.length > 0) {
            age[0].hidden = true;
        }

        var pqi = document.getElementsByName("PQIyear");
        if (pqi.length > 0) {
            pqi[0].hidden = false;
        }
    }

    AGESelected() {
        this.props.selectBackgroundLayer('Age');
        var age = document.getElementsByName("AGEyear");
        if (age.length > 0) {
            age[0].hidden = false;
        }

        var pqi = document.getElementsByName("PQIyear");
        if (pqi.length > 0) {
            pqi[0].hidden = true;
        }
    }

    HideYearSelect() {
        //console.log("hiding");
        var age = document.getElementsByName("AGEyear");
        if (age.length > 0) {
            age[0].hidden = true;
        }

        var pqi = document.getElementsByName("PQIyear");
        if (pqi.length > 0) {
            pqi[0].hidden = true;
        }
    }
}




// WEBPACK FOOTER //
// ./src/main-menu.js